import { createTheme } from "@mui/material";
import { components } from "./components/components";
import { colorSchemes } from "./color-schemes";
import { shadows } from "./shadows";
import { typography } from "./typography";

export const createAppTheme = (overrides?: object[]) =>
  createTheme({
    components,
    colorSchemes,
    shadows,
    typography,
    ...overrides,
  });
